import React from "react";
import styles from "./styles.module.scss";

const SpaceCardStyledSkeleton = () => {
    return (
        <div className={styles.spaceCardSkeleton}>
            {/* Skeleton content goes here if needed */}
        </div>
    )
};

export default SpaceCardStyledSkeleton;